import React, { Component } from 'react';
import moment from 'moment-timezone';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import axios from "axios";
import Tag from '../../components/Tag';

let cancelToken;
let state;
let tokenSession;

class ReservationContainer extends Component {

    getInitState = () => {
        return {
            reservation: [],
        };
    };

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel("Component will unmount.");
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }


    reload = () => {
        this.getReservation({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            reservation_id: this.props.match.params.reservationid,
        });
    };

    getReservation = (params) => {
        this.props.post(
            "/reservation_id",
            params,
            (response) => this.didGetReservation(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    };

    didGetReservation = (response) => {
        this.setState({ reservation: response });
    };

    handleErrorResponse = (error) => {
        alert(error);
    };


    render() {
        const reservation = this.state.reservation
        const { t } = this.props;
        const endDate = moment(reservation.fecha_final, 'YYYY-MM-DD HH:mm:ss');
        const startDate = moment(reservation.fecha_inicial, 'YYYY-MM-DD HH:mm:ss');
        const mapUrl = new URL(`https://www.google.com/maps/search/?api=1&query=${reservation.coordenadas}`);

        return (
            <div className="content-resvations">
                <div className="container-history-title">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="page-header">{t('dashboard.history.heading')}</h2>
                        </div>
                    </div>
                </div>
                <div className="container-room">
                    <div className="container-room-header card-panel panel panel-default card card_room card">
                        <div className="panel-heading" style={{ backgroundImage: "url('" + reservation.nombre_imagen + "')", borderRadius: '24px' }}>
                        </div>

                        <div className=" col-md-6">
                            <div className="panel-body-title">
                                <h2 className="ioscentro">{reservation.center_name}</h2>
                                <h4 className="iossala">{reservation.name}</h4>
                                <h4 className="iossala">{reservation.nombre}</h4>
                            </div>
                            <div className="panel-body-description">
                                <div className="panel-description-text">
                                    {reservation.description}
                                </div>
                                <div className="flex-tags flex-tags__big">
                                    <Tag
                                        isBigTag
                                        icon='people-group'
                                        text={t("venta_linea.reservation_tags.capacity")}
                                        value={`${reservation.capacidad} personas`}
                                    />
                                    <Tag
                                        isBigTag
                                        alt
                                        icon='calendar'
                                        text={t("venta_linea.reservation_tags.date")}
                                        value={startDate.format("ll")}
                                    />
                                    <Tag
                                        isBigTag
                                        icon='clock'
                                        text={t("venta_linea.reservation_tags.time")}
                                        value={`${startDate.format("HH:mm")} - ${endDate.format("HH:mm")}`}
                                    />
                                    <Tag
                                        isBigTag
                                        alt
                                        icon='user'
                                        text='Por:'
                                        value={reservation.quien}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            {reservation.services && (
                                <div className="container-room-description">
                                    <h4 className="page-header text-primary">
                                        <strong>{t('dashboard.history.heading_services')}</strong>
                                    </h4>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <p>
                                                <strong>{t('dashboard.history.heading_included')}</strong>
                                            </p>
                                            <div className="flex-tags">
                                                {reservation.services.map((service, index) =>
                                                    <Tag key={index} id={service.id} text={service.name} />
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <p>
                                                <strong>{t('dashboard.history.heading_extras')}</strong>
                                            </p>
                                            <div className="flex-tags">
                                                {reservation.extras.map((service, index) =>
                                                    <Tag key={index} id={service.id} text={service.name} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <section className="row">
                            <div className="col-md-6">
                                <div className="container-direction mapa">
                                    <div className="iframe-wrapper">
                                        <iframe
                                            frameBorder="0"
                                            src={
                                                "https://www.google.com/maps/d/embed?mid=1Cd02Lz4Q-XK73pQs9iA5jMJk86k&ll="
                                                + reservation.center_latitude
                                                + "%2C"
                                                + reservation.center_longitude
                                            }
                                            title={t('dashboard.reservation.frame_center')}>
                                        </iframe>
                                    </div>
                                </div>
                            </div>
                            <div className="container-room-direction col-md-6">
                                {reservation.direccion && (
                                    <div className="container-direction">
                                        <h4 className="page-header text-primary">
                                            <strong>{t('dashboard.history.heading_address')}</strong>
                                        </h4>
                                        <a href={mapUrl} target='_blank' style={{ textTransform: "capitalize" }}>
                                            <strong>{reservation.name}</strong>
                                            {reservation.direccion.split(",").map((row, index) =>
                                                <span key={index}>
                                                    <br />
                                                    {row.toLowerCase()}
                                                </span>
                                            )}
                                            <br />
                                            <span>{reservation.ciudad.toLowerCase()}</span>
                                            <br />
                                            <span>{reservation.estado.toLowerCase()}</span>
                                        </a>
                                    </div>
                                )}
                            </div>
                        </section>
                    </div>
                </div>

            </div >
        );
    }
}

export default compose(
    translate('common'),
    withRouter
)(ReservationContainer);



// WEBPACK FOOTER //
// ./src/dashboard/history/ReservationContainer.js